module.exports = __webpack_public_path__ + "static/media/move.2ade256c.svg";